import React, {useEffect, useState} from "react";
import {Outlet} from "react-router-dom";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import SiteTheme from "../../model/SiteTheme";
import AdventurersTheme from "../../themes/cga/AdventurersTheme";
import ChaseTheme from "../../themes/chase/ChaseTheme";
import DefaultTheme from "../../themes/DefaultTheme";
import _device_service from "../../services/DeviceService";
import './SiteLayout.scss';

interface SiteLayoutProps {
}

const SiteLayout = (props: SiteLayoutProps) => {

    const getTheme = (path: string): SiteTheme => {
        if (path && path.includes("cga")) {
            return AdventurersTheme;
        }

        return ChaseTheme;
    }
    
    const [theme, setTheme] = useState<SiteTheme>(DefaultTheme);

    const updateTheme = (path: string) => {
        setTheme(getTheme(path));
    }

    useEffect(() => {
        updateTheme(_device_service.getBrowserUrl());
    }, []);

    return (
        <>
            <Header theme={theme} themeUpdater={updateTheme}/>
            <div className="main-body">
                <div className="content-body">
                    <Outlet/>
                </div>
            </div>
            <Footer theme={theme} themeUpdater={updateTheme}/>
        </>
    );
}

export default SiteLayout;